import type { ChipProps } from '@mui/material';
import { Chip } from '@mui/material';
import { createScopedI18n } from '../../../../i18n/i18n';
import StatusIcon from './status_icon';

import type { JobHiringAttendance } from '../type';

const attendancePageI18n = createScopedI18n('pages.attendances', { joinOutput: true });

const statusMap: Record<JobHiringAttendance['status'], { label: string; color: ChipProps['color'] }> = {
  auto_approved: { label: attendancePageI18n('approve'), color: 'success' },
  manual_approved: { label: attendancePageI18n('approve'), color: 'success' },
  auto_rejected: { label: attendancePageI18n('reject'), color: 'error' },
  manual_rejected: { label: attendancePageI18n('reject'), color: 'error' },
};

export type StatusChipProps = {
  status: JobHiringAttendance['status'];
} & ChipProps;

const StatusChip = ({ status, ...props }: StatusChipProps) => {
  const statusInfo = statusMap[status as keyof typeof statusMap];

  if (!statusInfo) {
    return null;
  }

  return (
    <Chip
      variant="outlined"
      icon={<StatusIcon status={status} />}
      label={statusInfo.label}
      color={statusInfo.color}
      {...props}
    />
  );
};

export default StatusChip;
